export default "__VITE_ASSET__BGA5lViO__"